import { Surgery } from "../models";
import { displayDateNoYear } from "./displayDateAndTime";
import { getSurgeryTypeAbbreviation } from "./getSurgeryTypeAbbreviation";

export const getSurgeryName = (surgery?: Surgery) => {
    if (!surgery) return "";
    const surgeon = surgery.surgeon;
    return `${displayDateNoYear(surgery?.scheduledOnUtc)} ${surgeon?.firstName.charAt(0) ?? ""}. ${surgeon?.lastName ?? ""} ${getSurgeryTypeAbbreviation(surgery)} ${surgery?.recipientAge ?? ""} ${surgery?.recipientLastName ?? ""}`;
};
